import { render } from "./streamfutures.vue?vue&type=template&id=1a3ac63c&ts=true"
import script from "./streamfutures.vue?vue&type=script&lang=ts"
export * from "./streamfutures.vue?vue&type=script&lang=ts"

import "./streamfutures.vue?vue&type=style&index=0&id=1a3ac63c&lang=css"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__